// import React from "react";
// import { NavLink } from "react-router-dom";
// import Style from "./style.module.css";

// function SideBar({ children, routeConfig, ...props }) {
//   return (
//     <div className="d-none d-lg-block">
//       <div className={`${Style.sidenav}`}>
//         {routeConfig.map((route) => (
//           <NavLink
//           end
//           key={route.name}
//             className={({ isActive }) =>
//               isActive
//                 ? `${Style.nav_link} ${Style.active}`
//                 : `${Style.nav_link}`
//             }
//             to={route.path}
//           >
//             {<route.icon size={25} />}
//             {route.name}
//           </NavLink>
//         ))}
//       </div>
//       {children}
//     </div>
//   );
// }

// export default SideBar;

import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Style from "./style.module.css";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

function SideBar({ children, routeConfig, ...props }) {
  const [openRoutes, setOpenRoutes] = useState({});
  const location = useLocation();

  const toggleDropdown = (routeName) => {
    setOpenRoutes((prevState) => ({
      ...prevState,
      [routeName]: !prevState[routeName],
    }));
  };

  console.log("line 48");
  return (
    <div className="d-none d-lg-block">
      <div className={`${Style.sidenav}`}>
        {routeConfig.map((route) => (
          <div key={route.name}>
            <NavLink
              end
              className={({ isActive }) =>
                isActive && !route.children?.length
                  ? `${Style.nav_link} ${Style.active}`
                  : `${Style.nav_link}`
              }
              to={route.path}
              onClick={(e) => {
                if (route.children) {
                  e.preventDefault();
                  toggleDropdown(route.name);
                }
              }}
            >
              <route.icon size={25} />
              {route.name}
              {route.children && (
                <span onClick={() => toggleDropdown(route.name)}>
                  {openRoutes[route.name] ? (
                    <FiChevronUp
                      onClick={() => toggleDropdown(route.name)}
                      size={15}
                    />
                  ) : (
                    <FiChevronDown
                      onClick={() => toggleDropdown(route.name)}
                      size={15}
                    />
                  )}
                </span>
              )}
            </NavLink>
            {route.children && openRoutes[route.name] && (
              <div className={Style.dropdown}>
                {route.children.map((child) => (
                  <NavLink
                    key={child.name}
                    className={({ isActive }) =>
                      isActive
                        ? `${Style.nav_link} ${Style.active}`
                        : `${Style.nav_link}`
                    }
                    to={child.path}
                  >
                    <child.icon size={20} />
                    {child.name}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      {children}
    </div>
  );
}

export default SideBar;
